import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal,
  Button,
} from 'react-bootstrap';
import NoteFormRich from './NoteFormRich';

class AddNoteModel extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      note: ' ',
      disabled:true,
      BidId:this.props.BidId,
      proposalId: this.props.proposalId,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  };
  
  handleSubmit() {
    if( this.state.BidId != null && this.state.note != ' '){
      let payload ={'proposalId':this.state.proposalId,'bidId':this.state.BidId,'note':this.state.note} 
      let id = this.state.proposalId
      this.props.submitNoteData(id,payload);
      this.props.onClose();
    } else{
      alert("Please enter note");
    }  
  }
  takeInput(e){
    let val = e.target.value;
    if(val!=''){
      this.setState({
        note:val,
        disabled:false,
      })
    }
  }
  render() {
    const id = this.props.BidId;
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Note
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-sm-9">
                  <h3>Add note for sales person</h3><br/><br/>
                  <input id="inputField" type="text" placeholder="Enter Note" className="form-control" onChange={(e)=>this.takeInput(e)}/><br/>
                  <Button bsStyle="success" disabled={this.state.disabled} onClick={()=>this.handleSubmit()}>Add</Button>&nbsp;&nbsp;
                  <Button bsStyle="success" onClick={this.props.onClose}>Cancel</Button>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}


AddNoteModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddNoteModel;



// WEBPACK FOOTER //
// src/routes/booking/components/AddNoteModel.js